import React from 'react';
import {CardDetailsPage} from './WholeCode';
const ChoostseezCard = () => {
    return (
        <CardDetailsPage
            imgChoostSrc="https://mdbootstrap.com/img/Photos/Lightbox/Thumbnail/img%20(147).jpg"
            title="Choost Seez"
            choostSeezParagraph="Choost seez is an tasty food for eating, High in price and its very tasty you can order
                    easily from near hotel services or you can do it online services food for eating, High in price and its very tasty you can order
                    easily from near hotel services."
            Orderbtn="https://chipotle.com/order?utm_confid=uwk8j8a7m&utm_source=bing&utm_source=bing&utm_medium=cpc&utm_medium=cpc&utm_campaign=delivery&utm_campaign=Nonbrand_Delivery_Exact&msclkid=1a47636b9ff7142dbab33cd1c30ac1cc&utm_term=food%20delivery%20online&utm_content=Food%20Delivery&gclid=CJCR_uyWlu0CFY-DhQodh1QH8g&gclsrc=ds#menu"
            OrderbtnTitle="Order Now"
        />
    )
}
export default ChoostseezCard;